import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { Row as n, Col as p, Select as d } from "antd";
import { memo as y, useCallback as e } from "react";
import { l as x } from "../../../../lodash-DeBCDn4U.js";
import { GAInput as a } from "@biron-data/react-components";
import { useLanguageResolver as b } from "@biron-data/react-contexts";
const w = y(function({
  value: t,
  onChange: i,
  gaevent: f
}) {
  const r = b(), l = e((o) => {
    i == null || i({
      value: (t == null ? void 0 : t.value) ?? "",
      type: o
    });
  }, [i, t]), c = e((o) => {
    i == null || i({
      value: o,
      type: (t == null ? void 0 : t.type) ?? "prefix"
    });
  }, [i, t]);
  return /* @__PURE__ */ m(n, { children: [
    /* @__PURE__ */ s(p, { span: 8, children: /* @__PURE__ */ s(d, { options: [{
      value: null,
      label: r.get("configuration-metric-options.display.details.options.none")
    }, {
      value: "prefix",
      label: r.get("configuration-metric-options.display.details.options.prefix")
    }, {
      value: "suffix",
      label: r.get("configuration-metric-options.display.details.options.suffix")
    }], value: (t == null ? void 0 : t.type) ?? null, onChange: l }) }),
    /* @__PURE__ */ s(p, { span: 15, offset: 1, children: /* @__PURE__ */ s(
      a,
      {
        type: void 0,
        value: t == null ? void 0 : t.value,
        onChange: (o) => c(o.target.value),
        disabled: x.isEmpty(t == null ? void 0 : t.type),
        gaevent: f
      }
    ) })
  ] });
});
export {
  w as default
};
//# sourceMappingURL=DetailsSelector.js.map
